import type { TableBodyProps, TableHeadProps, TableProps, TableRowProps } from "@mui/material";
import { type ReactNode, createContext, useContext } from "react";

export interface ITableVirtualizedContext {
  slotProps?: {
    table?: Partial<TableProps>;
    tableHead?: Partial<TableHeadProps>;
    tableBody?: Partial<TableBodyProps>;
    tableRow?: Partial<TableRowProps>;
  };
}

const Context = createContext<ITableVirtualizedContext | null>(null);

export const useTableVirtualizedContext = (): ITableVirtualizedContext => {
  const value = useContext(Context);
  if (value === null) {
    throw new Error("useTableVirtualizedContext must be used within a TableVirtualizedProvider");
  }
  return value;
};

export interface ITableVirtualizedProviderProps extends ITableVirtualizedContext {
  children: ReactNode;
}

export const TableVirtualizedProvider = ({ children, ...rest }: ITableVirtualizedProviderProps) => {
  return <Context.Provider value={rest}>{children}</Context.Provider>;
};
